"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.deserializeCryptoOrgTransaction = exports.serializeCryptoOrgTransaction = void 0;
const bignumber_js_1 = __importDefault(require("bignumber.js"));
const serializeCryptoOrgTransaction = ({ family, mode, fees, amount, recipient, }) => {
    return {
        family,
        amount: amount.toString(),
        recipient,
        fees: fees ? fees.toString() : undefined,
        mode,
    };
};
exports.serializeCryptoOrgTransaction = serializeCryptoOrgTransaction;
const deserializeCryptoOrgTransaction = ({ family, mode, fees, amount, recipient, }) => {
    return {
        family,
        amount: new bignumber_js_1.default(amount),
        recipient,
        fees: fees ? new bignumber_js_1.default(fees) : undefined,
        mode,
    };
};
exports.deserializeCryptoOrgTransaction = deserializeCryptoOrgTransaction;
